import { StringConstants } from "global/constants/StringConstants";

class NotificationConstants extends StringConstants {
  GENERIC_ERROR = "An error has occurred";
  UPDATE = "Updated successfully";
  LOGGEDOUT = "You are logged out due to inactivity. Please login to continue.";
  BRANDING_SAVE_SUCCESS = "Branding saved successfully!";
  BRANDING_LOGO_UPLOAD_SUCCESS = "Logo uploaded successfully!";

  SIGNER_ATTACHMENTS_UPDATED = "Signer attachments has been updated";
  ATTACHMENT_ADDED = "Attachment added";
  ATTACHMENT_DELETED = "Attachment deleted";
  ATTACHMENT_UPLOAD_FAILED = "That file could not be attached. Please try again.";
  ATTACHMENT_DELETE_FAILED = "That file could not be removed. Please try again.";
  ATTACHMENT_LOAD_FAILED = "Your attachments could not be loaded.";
  ATTACHMENT_DOWNLOAD_FAILED = "That file could not be downloaded.";
  REQUEST_DOWNLOAD_UNAVAILABLE =
    "This request could not be loaded, so its documents can't be downloaded.";
  attachmentsAdded = (count: number) => `${count} attachments added`;
  attachmentsAttached = (count: number) =>
    count === 1 ? "1 file attached" : `${count} files attached`;
  attachmentLimitReached = (max: number) =>
    `You can attach a maximum of ${max} ${max === 1 ? "file" : "files"}.`;
  attachmentLimitTrimmed = (remaining: number, ignored: number) =>
    `Only ${remaining} more ${
      remaining === 1 ? "file" : "files"
    } can be attached. ${ignored} ${
      ignored === 1 ? "file was" : "files were"
    } ignored.`;

  // Contract Search
  CONTRACT_ANSWER_COPIED = "Answer copied";
  CONTRACT_SEARCH_FAILED = "Couldn't search your contracts. Please try again.";
  CONTRACT_DOCUMENTS_FAILED = "Your contracts could not be loaded. Please try again.";
  AWS_MARKETPLACE_INVALID_TOKEN = "We couldn't confirm your AWS Marketplace purchase. The setup link may have expired.";
  AWS_MARKETPLACE_UNAVAILABLE = "AWS Marketplace is not responding right now. Please try again in a few minutes.";
  AWS_MARKETPLACE_UNKNOWN_PRODUCT = "This AWS Marketplace subscription is not for Inkfree, or not for this environment.";
  AWS_MARKETPLACE_EXPIRED_CLAIM = "This setup link has expired or was already used.";
  AWS_MARKETPLACE_NOT_ADMIN = "Only an account administrator can link an AWS Marketplace subscription. Ask your admin to sign in and finish setup.";
  AWS_MARKETPLACE_LINK_FAILED = "We couldn't link your AWS Marketplace subscription. Please try again.";
  AWS_MARKETPLACE_INACTIVE = "Your Inkfree account is linked, but this AWS Marketplace subscription is no longer active, so your plan was not changed and billing stays with Inkfree.";
}

let notifiers = new NotificationConstants();
export default notifiers;
